module.exports = __webpack_public_path__ + "img/portfolio-box-layout-light.2f1a52a8.png";